import AhoyEvent from 'shared/ahoy_event';
import Page from 'shared/components/page';

export default class BaseDiscussion {
  constructor() {
    this.baseUI = {
      mainContainer:   '.livestreaming-discussion',
      toggleHide:      '.livestreaming-discussion__toggle',
      hideableItem:    '.js-livestreaming-discussion__hideable'
    };
  }

  init() {
    this.initToggleHideDiscussion();
  }

  initToggleHideDiscussion() {
    $(this.baseUI.toggleHide).on('click', function() {
      this.changeToggleButtonState();
      this.toggleDiscussionContainer();
      this.sendAhoyEvent();
    }.bind(this));
  }

  changeToggleButtonState() {
      const originalStateText = $(this.baseUI.toggleHide).attr('data-original-title');
      const toggleStateText =  originalStateText === 'Buka obrolan' ? 'Tutup obrolan' : 'Buka obrolan';
      $(this.baseUI.toggleHide).attr('data-original-title', toggleStateText);
      $(this.baseUI.toggleHide).toggleClass('livestreaming-discussion__toggle--hide');
      this.showTheTooltip();
  }

  toggleDiscussionContainer() {
      $(this.baseUI.mainContainer).toggleClass('livestreaming-discussion--collapse');
      $(this.baseUI.hideableItem).toggleClass('hide-me');
  }

  showTheTooltip() {
      $(this.baseUI.toggleHide).tooltip('show');
  }

  isDiscussionHidden() {
    return !!$(`${this.baseUI.hideableItem}.hide-me`).length;
  }

  sendAhoyEvent() {
    const livestreaming_id = Page.id();
    AhoyEvent.send('VIDIO::LIVESTREAMING', { action: 'click', feature: `chat-${this.isDiscussionHidden() ? 'close' : 'open'}`, livestreaming_id });
  }
} 
